export default __webpack_public_path__ + "static/mirai-magical-school-winter-festival_14-38d8882f32ef2de08b122c1d3779adeb.png";